import React, { useEffect, useRef } from 'react';
import { X } from 'lucide-react';

export const STUDIO_TUTORIAL_SEEN_KEY = 'seu.video.estudio.tutorialSeen.v1';
const VIDEO_SRC = `${process.env.PUBLIC_URL || ''}/estudio-tutorial.mp4`;

export function studioTutorialSeen(): boolean {
  try {
    return localStorage.getItem(STUDIO_TUTORIAL_SEEN_KEY) === '1';
  } catch {
    return true;
  }
}

export function markStudioTutorialSeen(): void {
  try {
    localStorage.setItem(STUDIO_TUTORIAL_SEEN_KEY, '1');
  } catch {
    /* storage unavailable */
  }
}

type Props = {
  open: boolean;
  onClose: () => void;
};

export default function StudioTutorialModal({ open, onClose }: Props) {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    const video = videoRef.current;
    if (video) {
      video.currentTime = 0;
      void video.play().catch(() => undefined);
    }
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="stu-tut" role="presentation" onClick={onClose}>
      <div
        className="stu-tut-card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="studio-tutorial-title"
        onClick={(e) => e.stopPropagation()}
      >
        <button type="button" className="stu-tut-close" aria-label="Fechar" onClick={onClose}>
          <X size={18} aria-hidden />
        </button>
        <div className="stu-tut-head">
          <span className="stu-tut-badge">Novo</span>
          <h2 id="studio-tutorial-title">Conheça o Estúdio</h2>
          <p>Cadastre os parâmetros, escreva o prompt com /nome e publique. Quem usa na home só preenche e gera.</p>
        </div>
        <div className="stu-tut-video">
          <video ref={videoRef} src={VIDEO_SRC} autoPlay muted playsInline loop preload="auto" />
        </div>
        <div className="stu-tut-actions">
          <button type="button" className="stu-tut-primary" onClick={onClose}>Começar agora</button>
        </div>
      </div>
    </div>
  );
}
